import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { PromotionByYear } from '../types/insights'

export function usePromotionsByYear() {
  return useQuery({
    queryKey: ['insights', 'promotions-by-year'],
    queryFn: async () => {
      const response = await get<{ data: PromotionByYear[] }>('/insights/promotions-by-year')
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
  })
} 